// extracted by mini-css-extract-plugin
export default {"widgets":"Home_widgets__JSiIu","charts":"Home_charts__R9LpL","listContainer":"Home_listContainer__p3zoU","listTitle":"Home_listTitle__JG6gh"};